import React, { useState, useEffect } from 'react';
import DemoModeService from '../services/demoMode';

/**
 * Banner that displays when app is in demo mode (server unavailable)
 * Allows reviewers to understand they're seeing demo data
 */
const DemoModeBanner = () => {
  const [isDemoMode, setIsDemoMode] = useState(false);
  const [isChecking, setIsChecking] = useState(false);

  useEffect(() => {
    // Check demo mode status every 10 seconds
    const checkDemoMode = () => {
      setIsDemoMode(DemoModeService.isDemoMode());
    };

    checkDemoMode();
    const interval = setInterval(checkDemoMode, 10000);

    return () => clearInterval(interval);
  }, []);

  const handleRetryConnection = async () => {
    setIsChecking(true);
    DemoModeService.forceServerCheck();
    
    // Wait a bit then recheck
    setTimeout(() => {
      setIsDemoMode(DemoModeService.isDemoMode());
      setIsChecking(false);
    }, 2000);
  };

  if (!isDemoMode) {
    return null;
  }

  return (
    <div style={styles.banner}>
      <div style={styles.content}>
        <div style={styles.iconContainer}>
          <span style={styles.icon}>📱</span>
        </div>
        <div style={styles.textContainer}>
          <div style={styles.title}>
            Demo Mode Aktiv
          </div>
          <div style={styles.description}>
            Serveren er ikke tilgjengelig. Appen kjører med demo-data.
            {'\n'}
            All funksjonalitet kan testes, men endringer lagres ikke.
          </div>
        </div>
        <button
          onClick={handleRetryConnection}
          disabled={isChecking}
          style={{
            ...styles.retryButton,
            opacity: isChecking ? 0.6 : 1,
          }}
        >
          {isChecking ? '🔄 Sjekker...' : '🔄 Prøv igjen'}
        </button>
      </div>
    </div>
  );
};

const styles = {
  banner: {
    backgroundColor: '#FFF3CD',
    borderBottom: '2px solid #FFC107',
    padding: '12px 16px',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  iconContainer: {
    flexShrink: 0,
  },
  icon: {
    fontSize: '24px',
  },
  textContainer: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontWeight: 'bold',
    fontSize: '16px',
    color: '#856404',
    marginBottom: '4px',
  },
  description: {
    fontSize: '13px',
    color: '#856404',
    whiteSpace: 'pre-line',
    lineHeight: '1.4',
  },
  retryButton: {
    backgroundColor: '#FFC107',
    color: '#000',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s',
    flexShrink: 0,
  },
};

export default DemoModeBanner;
